import axiosInstance from '../utils/axiosInstance';

const todoService = {
  async fetchTodos() {
    try {
      const resp = await axiosInstance.get('/admin/todos');
      if (Array.isArray(resp?.data?.todos)) {
        return resp.data.todos;
      }
      return [];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('todoService.fetchTodos failed', err);
      throw err;
    }
  },

  async createTodo(payload) {
    try {
      const resp = await axiosInstance.post('/admin/todos', payload);
      if (resp?.data?.todo) {
        return resp.data.todo;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('todoService.createTodo failed', err);
      throw err;
    }
  },

  async updateTodo(todoId, payload) {
    try {
      const resp = await axiosInstance.put(`/admin/todos/${todoId}`, payload);
      if (resp?.data?.todo) {
        return resp.data.todo;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('todoService.updateTodo failed', err);
      throw err;
    }
  },

  async updateStatus(todoId, status) {
    try {
      const resp = await axiosInstance.put(`/admin/todos/${todoId}/status`, { status });
      if (resp?.data?.todo) {
        return resp.data.todo;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('todoService.updateStatus failed', err);
      throw err;
    }
  },

  async deleteTodo(todoId) {
    try {
      await axiosInstance.delete(`/admin/todos/${todoId}`);
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('todoService.deleteTodo failed', err);
      throw err;
    }
  },
};

export default todoService;
